export default function Navbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-navy/85 border-b border-teal/10">
      <div className="container">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <a href="https://www.androhost.com" className="flex items-center gap-3 group">
            <img
              src="/androhost-rocket.svg"
              alt="AndroHost"
              className="h-10 w-auto group-hover:scale-110 transition-transform duration-300"
            />
            <span className="display text-2xl tracking-wider text-offwhite">
              ANDRO<span className="text-red">HOST</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="https://www.androhost.com" className="text-sm font-medium text-offwhite/80 hover:text-teal transition-colors">
              Home
            </a>
            <a href="https://www.androhost.com/#pricing" className="text-sm font-medium text-offwhite/80 hover:text-teal transition-colors">
              Pricing
            </a>
            <a href="https://discord.gg/9Y5zpKnfws" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-offwhite/80 hover:text-teal transition-colors">
              Discord
            </a>
            <span className="text-sm font-medium text-teal" aria-current="page">
              Status
            </span>
            <a href="https://panel.androhost.com" className="btn-primary" target="_blank" rel="noopener noreferrer">
              Launch Panel
            </a>
          </nav>

          <a href="https://panel.androhost.com" className="md:hidden text-sm font-medium text-teal" target="_blank" rel="noopener noreferrer">
            Panel
          </a>
        </div>
      </div>
    </header>
  );
}
